module.exports = __webpack_public_path__ + "assets/img/8645b52f933a18b028e28157d7c59faa.png";